import { render, staticRenderFns } from "./StockQuery.vue?vue&type=template&id=4cd20ae8&scoped=true&"
import script from "./StockQuery.vue?vue&type=script&lang=js&"
export * from "./StockQuery.vue?vue&type=script&lang=js&"
import style0 from "./StockQuery.vue?vue&type=style&index=0&id=4cd20ae8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cd20ae8",
  null
  
)

export default component.exports